export const Badge = ({ label, className }: { label: string | number; className?: string }) => {
  return <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>{label}</div>;
};
